module.exports = __webpack_public_path__ + "img/icon-push-all.bcf9a735.svg";